import {
  Logger_default
} from "./anacapri-chunk.J7V767XI.js";

// src/utilities/AnacapriElementsConfig.ts
var config = {
  dialogManager: {}
};
function getAnacapriElementsConfig() {
  return config;
}
function setAnacapriElementsConfig(configuration) {
  config = { ...config, ...configuration };
  if (config.elementPrefix) {
    Logger_default.logInfo(`set element tag prefix of '${config.elementPrefix}'.`);
  }
}

export {
  getAnacapriElementsConfig,
  setAnacapriElementsConfig
};
